import { GET_DOCTOR_ANALYTICS_GUEST_TOKEN } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export enum DOCTOR_ANALYTICS_GUEST_TOKEN_TYPE {
    ANALYTICS_DASHBOARD = 'analytics_dashboard',
    FD_ANALYTICS_DASHBOARD = 'fd_analytics_dashboard',
}

export interface Response {
    success: boolean;
    domain: string;
    embedded_id: string;
    guest_token: string;
    error?: string;
}

export default (type: DOCTOR_ANALYTICS_GUEST_TOKEN_TYPE): Promise<Response> => {
    return fetchWithRefresh(GET_DOCTOR_ANALYTICS_GUEST_TOKEN(type), {
        method: 'POST',
    }).then((res) => res.json());
};
